import { Visibility } from "@mui/icons-material";
import { Tooltip } from "@mui/joy";

// Marks a label or group that climbers can see.
export default function VisibleToClimbersIcon() {
  return (
    <Tooltip title="Visible to climbers">
      <Visibility fontSize="small" color="primary" />
    </Tooltip>
  );
}
